// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import { CAREER } from "../../../utility/constants";
import axios from "axios";
import {
  FETCH_CAREER_REQUEST,
  fetchCareerSuccess,
  fetchCareerFailure,
} from "../../actions/fetchCareerActions";

function* fecthcareer(action) {
  try {

    const response = yield call(axios.get, CAREER, {
      params: { page: action.payload},
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    if (response.status === 200 && response.data.status === "Success") {
      yield put(fetchCareerSuccess(response.data));
    }
  } catch (error) {
    yield put(fetchCareerFailure(error.message));
  }
}

export function* careerSaga() {
  yield takeLatest(FETCH_CAREER_REQUEST, fecthcareer);
}
export default careerSaga;
